import { Typography } from '@optimus-web/core';
import { SpacedDash, SpacedForwardSlash } from '@mews-commander/ui';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import {
    getTotalBlockPickUpCapacityByDate,
    areAllAdjustmentsReleasedByDate,
    getTotalBlocked,
} from '../../../../../selectors';
import { BlockSetupMatrixVectorTotalCell } from '../styles';
import { useAvailabilityBlockInfo } from '../../../../../utils/useAvailabilityBlockInfo';

interface TotalCellProps extends WithAvailabilityBlockId {
    dateTimeUtc: string;
}

const TotalCell = ({ dateTimeUtc, availabilityBlockId }: TotalCellProps) => {
    const { isConfirmed } = useAvailabilityBlockInfo(availabilityBlockId);
    const totalBlocked = useCommanderSelector((state) => getTotalBlocked(state, { availabilityBlockId, dateTimeUtc }));

    const totalPickedUp = useCommanderSelector((state) =>
        getTotalBlockPickUpCapacityByDate(state, { availabilityBlockId, dateTimeUtc })
    );

    const areAllAdjustmentsReleased = useCommanderSelector((state) =>
        areAllAdjustmentsReleasedByDate(state, { availabilityBlockId, dateTimeUtc })
    );
    if (!isConfirmed) {
        return (
            <BlockSetupMatrixVectorTotalCell>
                <Typography textStyle="bodySmallStrong" data-test-total as="div">
                    {totalBlocked}
                </Typography>
            </BlockSetupMatrixVectorTotalCell>
        );
    }
    return (
        <BlockSetupMatrixVectorTotalCell>
            <Typography textStyle="bodySmallStrong" data-test-total as="div">
                {totalPickedUp}
            </Typography>
            <Typography textStyle="bodySmall" variant="secondary" as="div">
                {SpacedForwardSlash}
                {areAllAdjustmentsReleased || totalBlocked === 0 ? SpacedDash : totalBlocked}
            </Typography>
        </BlockSetupMatrixVectorTotalCell>
    );
};

export default TotalCell;
